import type { StoryBlockProps } from "../../components/StoryBlock/StoryBlock";

export interface StoryBlockViewArgs {
  origin: StoryBlockProps["origin"];
  className: string;
  isLoading: boolean;
  isMobile: boolean;
  blockHeight: string;
}

export function getStoryBlockViewModel(args: StoryBlockViewArgs) {
  const { origin, className, isLoading, isMobile, blockHeight } = args;
  const isInfluencersOrigin = origin === "influencers";
  const isLiveOrigin = origin === "live";

  const sectionMinHeight = isLiveOrigin
    ? "min-h-[504px] md:min-h-[715px]"
    : "min-h-[504px] md:min-h-[684px]";
  const containerPadding = isInfluencersOrigin ? "py-[16px]" : "py-0";
  const containerClasses = isInfluencersOrigin
    ? `storyBlock relative flex justify-center ${containerPadding}`
    : `storyBlock relative flex h-full items-start justify-center ${containerPadding}`;

  let containerMinHeight = "auto";
  if (isLoading && (isInfluencersOrigin || isLiveOrigin)) {
    if (isInfluencersOrigin) {
      containerMinHeight = isMobile ? "504px" : "684px";
    } else {
      containerMinHeight = blockHeight;
    }
  }

  const influencersSectionClassName = `fw-story-block ${sectionMinHeight} ${className}`;
  const liveSectionStyle = {
    minHeight: blockHeight,
    height: blockHeight,
    overflow: "hidden" as const,
    padding: "0px 45px",
  };

  const influencersContainerStyle = { minHeight: containerMinHeight, zIndex: "4 !important" };
  const liveContainerStyle = {
    minHeight: containerMinHeight,
    height: "100%",
  };

  const influencersStoryblockStyle = { opacity: 1, height: blockHeight };
  const liveStoryblockStyle = {
    opacity: 1,
    display: "block" as const,
    width: "100%",
    maxWidth: isMobile ? "100%" : "520px",
    margin: "0 auto",
    height: blockHeight,
  };

  return {
    isInfluencersOrigin,
    isLiveOrigin,
    containerClasses,
    influencersSectionClassName,
    liveSectionStyle,
    influencersContainerStyle,
    liveContainerStyle,
    influencersStoryblockStyle,
    liveStoryblockStyle,
  };
}
